export default __webpack_public_path__ + "static/8-1c7b3d045692ca21c2721e15ba30b284.jpg";